/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRvHookupIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-rv-hookup"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.82 21.9Q7.83 21.9 7.01 21.32Q6.2 20.75 5.75 19.85L4.45 19.85Q3.05 19.85 2.05 18.88Q1.05 17.9 1.05 16.5L1.05 12.4Q1.05 11.28 1.81 10.51Q2.58 9.75 3.7 9.75L7.5 9.75L7.5 6.7L2.38 6.7Q1.82 6.7 1.44 6.31Q1.05 5.92 1.05 5.38Q1.05 4.83 1.44 4.44Q1.82 4.05 2.38 4.05L14.95 4.05Q16.05 4.05 16.82 4.83Q17.6 5.6 17.6 6.7L17.6 17.2L18.85 17.2L18.85 17.2Q18.52 16.88 18.56 16.43Q18.6 15.97 19.02 15.53Q19.43 15.13 19.96 15.11Q20.5 15.1 20.9 15.5L23.02 17.63Q23.43 18.02 23.43 18.55Q23.43 19.07 23.02 19.48L20.88 21.63Q20.5 22 19.95 22Q19.4 22 18.93 21.52Q18.57 21.18 18.56 20.69Q18.55 20.2 18.9 19.85L18.9 19.85L11.9 19.85Q11.47 20.75 10.65 21.32Q9.82 21.9 8.82 21.9ZM10.15 9.75L14.95 9.75L14.95 6.7Q14.95 6.7 14.95 6.7Q14.95 6.7 14.95 6.7L10.15 6.7ZM8.82 19.25Q8.82 19.25 8.97 19.25Q9.13 19.25 9.34 19.04Q9.55 18.82 9.55 18.52Q9.55 18.23 9.34 18.01Q9.13 17.8 8.82 17.8Q8.53 17.8 8.31 18.01Q8.1 18.23 8.1 18.52Q8.1 18.82 8.31 19.04Q8.53 19.25 8.82 19.25Z" fill={color} />
    </svg>
  );
}
